export interface SettingInfo {
  subDiscountsManage: 0 | 1; // 0代表不开启 1代表开启
  partnerIdType:
    | 'COOPERATION' // 转售（合作）
    | 'CHANNEL' //转介（渠道）
    | 'CHANNEL_COOPERATION' //转售+PO 历史遗留字段，没有实际用过
    | 'WHITE_LABEL'; //白标
}

let settingInfo: SettingInfo | undefined;

export const getSettingInfo = (): SettingInfo | undefined => {
  return settingInfo;
};

export const setSettingInfo = (_settingInfo: SettingInfo) => {
  settingInfo = _settingInfo;
};

export const removeSettingInfo = () => {
  settingInfo = undefined;
};
